module.exports = "/assets/images/cc455dbb3e9078d65992af5cf6925f60.svg";